import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Linkedin, Mail } from 'lucide-react';
import Logo from './Logo';

const Footer = () => {
  return (
    <footer className="border-t border-slate-200 py-12 bg-white" data-testid="footer">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 mb-8">
          {/* Services */}
          <div>
            <h4 className="font-semibold mb-3 text-sm text-slate-900">Services</h4>
            <ul className="space-y-2 text-sm text-slate-600">
              <li><Link to="/pricing?category=business-setup" className="hover:text-slate-900 transition-colors">Business Setup</Link></li>
              <li><Link to="/pricing?category=licenses" className="hover:text-slate-900 transition-colors">Licenses</Link></li>
              <li><Link to="/pricing?category=trademark" className="hover:text-slate-900 transition-colors">Trademark</Link></li>
              <li><Link to="/pricing?category=gst" className="hover:text-slate-900 transition-colors">GST</Link></li>
              <li><Link to="/pricing?category=tax-payroll" className="hover:text-slate-900 transition-colors">Tax & Payroll</Link></li>
            </ul>
          </div>
          
          {/* All Services */}
          <div>
            <h4 className="font-semibold mb-3 text-sm text-slate-900">All Services</h4>
            <ul className="space-y-2 text-sm text-slate-600">
              <li><Link to="/pricing" className="hover:text-slate-900 transition-colors">View All Services</Link></li>
            </ul>
          </div>
          
          {/* Company */}
          <div>
            <h4 className="font-semibold mb-3 text-sm text-slate-900">Company</h4>
            <ul className="space-y-2 text-sm text-slate-600">
              <li><Link to="/about" className="hover:text-slate-900 transition-colors">About Us</Link></li>
              <li><Link to="/contact" className="hover:text-slate-900 transition-colors">Contact Us</Link></li>
            </ul>
          </div>
          
          {/* Legal */}
          <div>
            <h4 className="font-semibold mb-3 text-sm text-slate-900">Legal</h4>
            <ul className="space-y-2 text-sm text-slate-600">
              <li><Link to="/privacy" className="hover:text-slate-900 transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-slate-900 transition-colors">Terms & Conditions</Link></li>
              <li><Link to="/terms" className="hover:text-slate-900 transition-colors">Refund Policy</Link></li>
            </ul>
          </div>
          
          {/* Brand Column */}
          <div>
            <div className="mb-3">
              <Logo size="small" linkTo="/" />
            </div>
            <p className="text-sm text-slate-600 mb-4">
              Powered by AI. Reviewed by experts.
            </p>
            <div className="flex gap-3">
              <a href="#" className="text-slate-400 hover:text-slate-600 transition-colors" aria-label="Facebook">
                <Facebook className="h-4 w-4" />
              </a>
              <a href="#" className="text-slate-400 hover:text-slate-600 transition-colors" aria-label="Twitter">
                <Twitter className="h-4 w-4" />
              </a>
              <a href="#" className="text-slate-400 hover:text-slate-600 transition-colors" aria-label="LinkedIn">
                <Linkedin className="h-4 w-4" />
              </a>
              <a href="#" className="text-slate-400 hover:text-slate-600 transition-colors" aria-label="Email">
                <Mail className="h-4 w-4" />
              </a>
            </div>
          </div>
        </div>
        
        <div className="border-t border-slate-200 pt-8 text-center text-sm text-slate-500">
          <p>&copy; 2025 <span className="bg-gradient-to-r from-blue-600 via-violet-600 to-emerald-600 bg-clip-text text-transparent font-semibold">COMPLY</span><span className="text-slate-900 font-semibold">KIT</span>. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
